import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchLatestCommunication, markCommunicationAsViewed } from './notificationApi';
import debounce from 'lodash.debounce';

const initialState = {
  notification_data: null,
  show: false,
  error: ''
};

// NOTE: Do not debounce the payload creator itself. Debounce the dispatch instead.
export const loadCurrentNotification = createAsyncThunk(
  'notificationManager/loadCurrentNotification',
  async () => {
    const response_communication = await fetchLatestCommunication();
    if (response_communication?.success) {
      return response_communication?.data;
    }
    return response_communication;
  }
);

// Debounced dispatcher helper: dispatch(loadCurrentNotificationDebounced()) to debounce calls by 5s
let _debouncedLoader;
export const loadCurrentNotificationDebounced = () => (dispatch) => {
  if (!_debouncedLoader) {
    _debouncedLoader = debounce(() => {
      dispatch(loadCurrentNotification());
    }, 5000, { leading: false, trailing: true });
  }
  _debouncedLoader();
};

export const closeCommunicationModal = createAsyncThunk(
  'notificationManager/closeCommunicationModal',
  async (communication_id, thunkAPI) => {
    
    const response_communication = await markCommunicationAsViewed(communication_id);
    if (response_communication?.success) { 
      return true
    } else {
      return response_communication
    }
  }
);

export const notificationSlice = createSlice({
  name: 'notificationManager',
  initialState,
  extraReducers: (builder) => {
      builder
        .addCase(loadCurrentNotification.fulfilled, (state, action) => {
          if(!action?.payload?.error){
            state.notification_data = action?.payload;
            state.show = action?.payload ? true : false
          } else {
            state.error = action?.payload?.error;
          }  
            
        })
        .addCase(closeCommunicationModal.fulfilled, (state, action) => {
          if(!action?.payload?.error){
            state.notification_data = null;
            state.show = false
          } else {
            state.error = action?.payload?.error;
          }  
            
        });
    },
});

export const selectCurrentNotificationData = (state) => state.notificationManager;

export default notificationSlice.reducer;
